import React, { Component } from "react";
import PropTypes from "prop-types";
import "./BrandsListItem.scss";

export class BrandsListItem extends Component {
  static propTypes = {
    name: PropTypes.string,
    logo: PropTypes.string,
    picture: PropTypes.string,
  };

  render() {
    const { logo, picture, size } = this.props;
    return (
      <>
        <div
          className="brands-list-item"
          style={{
            height: "calc(14rem + (" + size + " * 16rem))",
            backgroundImage: "url(" + picture + ")",
          }}
        >
          <img className="item_logo" src={logo} alt="" />
        </div>
      </>
    );
  }
}

export default BrandsListItem;
